export function getNextDate(date) {
    // Create a new Date object based on the input date
    const nextDate = new Date(date);
    
    // Add one day (24 hours) to the date
    nextDate.setDate(nextDate.getDate() + 1);
    
    return nextDate;
}
